var _style, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st19{fill:#c8421d}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3 122.3c32 0 58-26 58-58h-116c0 32.1 26 58 58 58z",
    className: "st19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8f6a",
    d: "M70.3 6.3v58h58c0-32-25.9-58-58-58z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed6b47",
    d: "M12.4 64.3h58v-58c-32 0-58 26-58 58z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 96.5h-53c-3.5 0-6.4-2.9-6.4-6.4V37.9c0-3.5 2.9-6.4 6.4-6.4h53c3.5 0 6.4 2.9 6.4 6.4v52.2c0 3.5-2.9 6.4-6.4 6.4z",
    className: "st19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.3 68.6v13.7h-7.7V44.5h15.3c4.4 0 7.9 1.1 10.4 3.3 2.5 2.2 3.8 5.1 3.8 8.8 0 3.6-1.3 6.5-3.8 8.7-2.5 2.2-6 3.3-10.4 3.3h-7.6zm0-5.8h7.6c2.1 0 3.8-.6 4.9-1.7 1.1-1.2 1.7-2.6 1.7-4.4 0-1.8-.5-3.3-1.6-4.5-1.1-1.2-2.7-1.8-4.9-1.8h-7.6v12.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 37.3V90.1c0 3.5-2.9 6.4-6.4 6.4H22.3l3.8 5.7h38.3c3.5 0 6.4-2.9 6.4-6.4V43.6c.1-3.2-2.2-5.9-5.3-6.3z",
    opacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.45477d58.svg";
export { ForwardRef as ReactComponent };